import request from '@/blocks/request';

export function getShareInfo(params) {
  return request({
    useLoading: true,
    url: `/user/share`,
    params,
  });
}

export function uploadImage(data) {
  return request({
    useLoading: true,
    method: 'POST',
    baseURL: process.env.VUE_APP_PANGKU_WWW,
    url: '/v1/common/alipay/upload',
    data,
  });
}
